module.exports = __webpack_public_path__ + "img/lines.f6db3528.svg";